@if (teaserBetState) {
    <div class="picks">
        <bs-digital-pick-list>
            @for (pick of teaserPickList; track pick.id.toString()) {
                <bs-teaser-bet-pick
                    [pick]="pick"
                    [oddsDisplayFormat]="oddsDisplayFormat"
                    [teaserBetState]="teaserBetState"
                    [msAutomation]="pick.id.toString()" />
            }
        </bs-digital-pick-list>
    </div>
}
